import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as allReducers from './reducers';
import history from './history';
import StateManager from 'utilities/state';
import allMiddleware from './state';
import { createLogger } from 'redux-logger';

const loggerMiddleware = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error
  });

const middleware = process.env.NODE_ENV === 'development'
    ? [thunk, loggerMiddleware, routerMiddleware(history)]
    : [thunk, routerMiddleware(history)];

// In development, use the browser's Redux dev tools extension if installed
const enhancers = [];

const isDevelopment = process.env.NODE_ENV === 'development';
if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ) {
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());    
}

const rootReducer = combineReducers({
    ...allReducers,
    routing: routerReducer
});

const stateManager = new StateManager();

stateManager.applyMiddleware(allMiddleware);

const sanitiseInitialState = (initialState) => {
    return initialState;
};

export default async function () {

    const initialState = await stateManager.initialiseState();
    const sanitisedState = sanitiseInitialState(initialState);

    const store = createStore(
        rootReducer,
        sanitisedState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );

    store.subscribe(async () => await stateManager.onStateChanged(store.getState()));

    store.history = history;

    return store;
}